import { connect } from 'react-redux';
import { fetchAppAccessControlUsers,
    updateAppAccessControlSwitchAction, getAppAccessControlSwitchAction,
    appAccessControlDeleteUserAction, aacDownloadSampleCsvAction,
    appAccessControlImportUsersAction, appAccessControlImportUsersSuccess,
    aacExportUsersAction } from 'Actions/appAccessControlAction';
import AppAccessControl from 'Components/AppAccessControl';

function mapStatetoProps(state){
    return {
        appAccessControlUsers: state.appAccessControlUsers,
        appAccessControlSwitch: state.appAccessControlSwitch,
        appAccessControlDeleteUser: state.appAccessControlDeleteUser,
        permissions:state?.profile?.permission && JSON.parse(state.profile.permission),
        appAccessControlImportUsers: state.appAccessControlImportUsers,
        aacDownloadSampleCsv: state.aacDownloadSampleCsv,
        aacExportUsers: state.aacExportUsers
    }
}

const mapDispatchtoProps = {
    fetchAppAccessControlUsers,
    updateAppAccessControlSwitchAction,
    getAppAccessControlSwitchAction,
    appAccessControlDeleteUserAction,
    aacDownloadSampleCsvAction,
    appAccessControlImportUsersAction,
    appAccessControlImportUsersSuccess,
    aacExportUsersAction
}

export default connect(mapStatetoProps,mapDispatchtoProps)(AppAccessControl)